export default value =>
  value
    .toLowerCase()
    .replace(/[,.]/g, '')
    .replace(/ /g, '_');
